import React, { useMemo } from 'react';
import classNames from 'classnames';

// components
import { Icon } from 'components/atoms/Icon';

// styles
import sharedStyles from 'styles/shared/container.module.css';
import styles from './footer.module.css';
import { Socials } from 'components/organisms/Socials/Socials';

export const Footer = () => {
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer
      className={classNames(sharedStyles.container, styles.footerContainer)}
    >
      <div className={styles.footer}>
        <div className={styles.copyrightBlock}>
          <Icon id="copyright" className={styles.footerIcon} />
          <div className={styles.footerText}>{year} Mavryk Dynamics</div>
        </div>

        <Socials />
      </div>
    </footer>
  );
};
